import { LanguageItem } from '@core/models/interfaces/system';

export const LANGUAGES: LanguageItem[] = [
  { name: 'English', code: 'US', language: 'en' },
  { name: 'Vietnamese', code: 'VN', language: 'vi' }
];

export const COUNTRY_CODES = ['+1'];
